<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="类型id" prop="goodsId" >-->
<!--        <a-input v-model="form.goodsId" placeholder="请输入类型id" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="评论内容" prop="content" >
<!--        <editor v-model="form.content" />-->
        <a-input v-model="form.content" type="textarea" placeholder="请输入评论内容" />
      </a-form-model-item>
<!--      <a-form-model-item label="类型:0普通 1-作者" prop="userType" >-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="发评论人id, zb_user-id" prop="userId" >-->
<!--        <a-input v-model="form.userId" placeholder="请输入发评论人id, zb_user-id" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="回复他人id, zb_user-id" prop="replyUserId" >-->
<!--        <a-input v-model="form.replyUserId" placeholder="请输入回复他人id, zb_user-id" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="回复评论id, 上级评论id, zb_user_dynamic_comment-id" prop="replyCommentId" >-->
<!--        <a-input v-model="form.replyCommentId" placeholder="请输入回复评论id, 上级评论id, zb_user_dynamic_comment-id" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="一级评论id" prop="topCommentId" >-->
<!--        <a-input v-model="form.topCommentId" placeholder="请输入一级评论id" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="点赞数量" prop="likeCount" >-->
<!--        <a-input v-model="form.likeCount" placeholder="请输入点赞数量" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="类型:0-畅聊吧帖子 1-派对场帖子 2-品牌馆分类" prop="type" >-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getComment, addComment, updateComment } from '@/api/user/comment'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        goodsId: null,

        content: null,

        userType: null,

        userId: null,

        replyUserId: null,

        replyCommentId: null,

        topCommentId: null,

        likeCount: null,

        createTime: null,

        remark: null,

        type: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goodsId: [
          { required: true, message: '类型id不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '评论内容不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '发评论人id, zb_user-id不能为空', trigger: 'blur' }
        ],
        likeCount: [
          { required: true, message: '点赞数量不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        goodsId: null,
        content: null,
        userType: null,
        userId: null,
        replyUserId: null,
        replyCommentId: null,
        topCommentId: null,
        likeCount: null,
        createTime: null,
        remark: null,
        type: null
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset();
      this.form = {
        id: null,
        goodsId: row.goodsId,
        content: null,
        replyCommentId: row.replyCommentId,
        type: row.type
      }
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getComment({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateComment(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addComment(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
